(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerWrapper = document.querySelector('.header-wrapper');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      
      // Initialize compact menu
      this.initCompactMenu();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    initCompactMenu() {
      const compactMenuToggle = document.querySelector('.compact-menu__toggle');
      const compactMenuDropdown = document.getElementById('compact-menu-dropdown');
      
      if (compactMenuToggle && compactMenuDropdown) {
        // Desktop: Click to toggle
        compactMenuToggle.addEventListener('click', (event) => {
          event.stopPropagation();
          const isOpen = compactMenuToggle.getAttribute('aria-expanded') === 'true';
          compactMenuToggle.setAttribute('aria-expanded', !isOpen);
          compactMenuDropdown.classList.toggle('is-open');
        });
        
        // Desktop: Close when clicking outside
        document.addEventListener('click', (event) => {
          if (!compactMenuToggle.contains(event.target) && !compactMenuDropdown.contains(event.target)) {
            compactMenuToggle.setAttribute('aria-expanded', 'false');
            compactMenuDropdown.classList.remove('is-open');
          }
        });
        
        // Desktop: Close when mouse leaves the dropdown
        compactMenuDropdown.addEventListener('mouseleave', () => {
          compactMenuToggle.setAttribute('aria-expanded', 'false');
          compactMenuDropdown.classList.remove('is-open');
        });
        
        // Prevent dropdown from closing when scrolling inside it
        compactMenuDropdown.addEventListener('wheel', (event) => {
          event.stopPropagation();
        }, { passive: true });
        
        // Mobile: Touch events
        let touchStartTime;
        let touchStartY;
        
        compactMenuToggle.addEventListener('touchstart', (event) => {
          touchStartTime = new Date().getTime();
          touchStartY = event.touches[0].clientY;
        }, { passive: true });
        
        compactMenuToggle.addEventListener('touchend', (event) => {
          const touchEndTime = new Date().getTime();
          const touchEndY = event.changedTouches[0].clientY;
          const touchDuration = touchEndTime - touchStartTime;
          const touchDistance = Math.abs(touchEndY - touchStartY);
          
          // Only toggle if it's a quick tap (not a scroll)
          if (touchDuration < 300 && touchDistance < 10) {
            event.preventDefault();
            const isOpen = compactMenuToggle.getAttribute('aria-expanded') === 'true';
            compactMenuToggle.setAttribute('aria-expanded', !isOpen);
            compactMenuDropdown.classList.toggle('is-open');
          }
        }, { passive: false });
        
        // Mobile: Close when touching outside
        document.addEventListener('touchstart', (event) => {
          if (!compactMenuToggle.contains(event.target) && !compactMenuDropdown.contains(event.target)) {
            compactMenuToggle.setAttribute('aria-expanded', 'false');
            compactMenuDropdown.classList.remove('is-open');
          }
        }, { passive: true });
        
        // Mobile: Close when scrolling
        let scrollTimeout;
        window.addEventListener('scroll', () => {
          if (compactMenuDropdown.classList.contains('is-open')) {
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => {
              compactMenuToggle.setAttribute('aria-expanded', 'false');
              compactMenuDropdown.classList.remove('is-open');
            }, 150);
          }
        }, { passive: true });
        
        // Mobile: Prevent dropdown from closing when scrolling inside it
        compactMenuDropdown.addEventListener('touchmove', (event) => {
          event.stopPropagation();
        }, { passive: true });
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
